import { api, makeApiRequest } from 'api/_init'

/**
 * @typedef {Object} TestCampaignPayload
 * @property {string} ad_account_id - Facebook ad account id
 * @property {string} profile_id - Facebook profile id
 * @property {string} [instagram_actor_id] - Facebook instagram actor id
 * @property {string} [pixel_id] - Facebook pixel id
 */

/**
 * @typedef {Object} TestCampaignError
 * @property {string} error_type
 * @property {string} title
 * @property {string} message
 * @property {number} [code]
 * @property {number} [subcode]
 * @property {string} category
 */

/**
 * @typedef {Object} TestCampaign
 * @property {number} id
 * @property {string} partner_id
 * @property {string} ad_account_id
 * @property {string} [campaign_id]
 * @property {string} [campaign_name]
 * @property {string} [task_id]
 * @property {TestCampaignError} [error]
 * @property {string} [error_category]
 * @property {string} status
 * @property {string} [stage]
 * @property {string} date_created
 * @property {string} date_last_updated
 */

/**
 * @typedef {Object} TestCampaignStatusResponse
 * @property {TestCampaign|null} ongoing_campaign
 */

const testCampaignApi = {
  /**
   * Create a new test campaign
   * @param {TestCampaignPayload} payload
   * @returns {Promise<{data?: TestCampaign, error?: any}>}
   */
  createTestCampaign: async (payload) => {
    return await makeApiRequest(
      api,
      'post',
      '/integrations/connect/facebook/test-campaign',
      payload,
      { timeout: 0 },
    )
  },

  /**
   * Get ongoing test campaign status
   * @returns {Promise<{data?: TestCampaignStatusResponse, error?: any}>}
   */
  getOngoingCampaign: async () => {
    return await makeApiRequest(api, 'get', '/integrations/connect/facebook/test-campaign')
    // return fake ongoing campaign for testing
    // return {
    //   data: {
    //     ongoing_campaign: {
    //       id: 1,
    //       partner_id: 'partner_123',
    //       ad_account_id: 'act_123',
    //       campaign_id: 'camp_123',
    //       campaign_name: 'Test Campaign',
    //       task_id: 'task_123',
    //       status: 'in_progress',
    //       stage: 'creating_campaign',
    //       date_created: '2026-03-10T014:22:00Z',
    //       date_last_updated: '2026-03-10T014:22:00Z',
    //     },
    //   },
    // }
  },

  /**
   * Get specific test campaign by ID
   * @param {number} campaignId
   * @returns {Promise<{data?: TestCampaign, error?: any}>}
   */
  getTestCampaignById: async (campaignId) => {
    return await makeApiRequest(
      api,
      'get',
      `/integrations/connect/facebook/test-campaign?id=${campaignId}`,
    )
  },
}

export default testCampaignApi
